__turbopack_context__.v({
  "Actions": "_index-module__v2iaJW__Actions",
  "Backdrop": "_index-module__v2iaJW__Backdrop",
  "Button": "_index-module__v2iaJW__Button",
  "Container": "_index-module__v2iaJW__Container",
  "DangerButton": "_index-module__v2iaJW__DangerButton",
  "Description": "_index-module__v2iaJW__Description",
  "Intro": "_index-module__v2iaJW__Intro",
  "Popup": "_index-module__v2iaJW__Popup",
  "Title": "_index-module__v2iaJW__Title",
});
